import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Banner.module.css";
import heroImage from "../assets/bg1.png";

export default function Banner() {
  const navigate = useNavigate();

  const handleContact = () => {
    navigate("/contact");
  };

  return (
    <section
      className={styles.banner}
      style={{ backgroundImage: `url(${heroImage})` }}
    >
      <div className={styles.overlay} />

      <div className={styles.inner}>
        <div className={styles.content}>
          <h1 className={styles.title}>
            Growing minds through <span>fun & play</span>
          </h1>

          <p className={styles.desc}>
            At Happy Horizon, every child is welcomed with warmth, and every
            visit is thoughtfully designed to leave them smiling.
          </p>

          <div className={styles.actions}>
            <button
              className={styles.primary}
              onClick={handleContact}
            >
              Contact Us
            </button>

          </div>
        </div>
      </div>
    </section>
  );
}
